import { useQuery } from '@tanstack/react-query';
import React, { useEffect } from 'react';
import { getListIDPClientFlowQuery } from '../apis';
import { setFieldIDPClients } from '..';
import { deepClone } from '@tenant/utility/helper/Utils';
import { useDispatch } from 'react-redux';
import queryKeyAppInstance from '../constants/queryKeyAppInstance';

const useGetListIDPClientFlow = () => {
  const dispatch = useDispatch();

  const getListIDPClients = useQuery({
    queryKey: queryKeyAppInstance.getList(
      'flow',
    ),
    queryFn: () => getListIDPClientFlowQuery(),
  });

  useEffect(() => {
    const data =
      typeof getListIDPClients !== 'undefined'
        ? getListIDPClients?.data?.data
        : [];

    if (data) {
      dispatch(
        setFieldIDPClients({
          field: 'optionsFlow',
          value: deepClone(data),
        }),
      );
    }
  }, [getListIDPClients?.data, dispatch]);

  return getListIDPClients;
};

export default useGetListIDPClientFlow;
